<template>
<section>
  <b-modal id='info-modal' centered scrollable hide-footer size="lg" title="More Info">
    Shows prices, costs, and margins of parts (am-%, EVO-%, BT%, gs%, and ps%).<br/>
    This report does not show KITs or inactive products, but it does show items that we do not have inventory of (though it doesn't show FIFO cost for obvious reasons).<br/>
    Margin Equation: (Product price - FIFO Cost) / Product price * 100 | (Avg Cost will be used if FIFO Cost N/A)<br/>
    Markup Equation: (Product price - FIFO Cost) / FIFO Cost * 100 | (Avg Cost will be used if FIFO Cost N/A)
  </b-modal>
  <b-container fluid>
    <b-row>
      <b-col>
        <h3>Pricing Margin Report
          <b-button size="sm" variant='link' v-b-modal.info-modal class="px-0">
            <i class="fas fa-question-circle"></i>
          </b-button>
        </h3>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <b-form @submit="searchForItems">
          <b-form-row class="mb-2">
            <b-col>
              <b-form-input
                id="partNum"
                placeholder="Part Number"
                v-model="search.partNum"
              />
            </b-col>
            <b-col>
              <b-form-input
                id="partDesc"
                placeholder="Part Description"
                v-model="search.partDesc"
              />
            </b-col>
            <b-col>
              <b-form-select id="monthStart" v-model="search.monthStart" :options="[...[{ value: null, text: 'Date Range Start' }], ...months]" />
            </b-col>
            <b-col>
              <b-form-select id="monthEnd" v-model="search.monthEnd" :options="[...[{ value: null, text: 'Date Range End' }], ...months]" />
            </b-col>
            <b-button type="submit" variant="primary">Search</b-button>
          </b-form-row>

          <b-row class="mb-n3">
            <b-col>
              <p>Sort Field</p>
            </b-col>
            <b-col>
              <p>Sort Ascending/Descending</p>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-select
                @change="searchForItems"
                v-model="sort.field"
                :options="columns"
              ></b-form-select>
            </b-col>

            <b-col>
              <b-form-select
                @change="searchForItems"
                v-model="sort.dir"
                :options="['asc', 'desc']"
              ></b-form-select>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-alert v-if=alert.show show :variant=alert.variant>{{alert.message}}</b-alert>
        <b-alert v-else-if="!!html && !html.includes('<td>')" show variant=warning>
          This is either an inactive part or does not exist
        </b-alert>
      </b-col>
    </b-row>

    <b-row>
      <fingerprint-spinner
        :animation-duration="1500"
        :size="300"
        color="#293a93"
        class="align-middle"
        v-if="busy"
      />
      <b-col v-html="html" v-else> </b-col>
    </b-row>
  </b-container>
</section>
</template>



<script>
import axios from "axios";
import { FingerprintSpinner } from "epic-spinners";
import { mapActions } from "vuex";
const BASE_API = process.env.VUE_API_ROOT;

export default {
  components: {
    FingerprintSpinner,
  },
  mounted() {
    if (Object.keys(this.$route.query).length > 0) {
      Object.keys(this.$route.query).forEach((index, key) => {
        if (Object.prototype.hasOwnProperty(this.search, key)) {
          this.search[key] = this.$route.query[key];
        }
      });
      this.searchForItems();
    } else {
      this.search.partNum = "";
      this.search.partDesc = "";
      this.sort.field = "margin";
      this.sort.dir = "asc";
      this.searchForItems();
    }
  },

  data() {
    return {
      busy: false,
      columns: [ // this is just the options for the 'sort by' selector
        { value: "num", text: "Part Number" },
        { value: "description", text: "Description" },
        { value: "price", text: "Price" },
        { value: "fifocost", text: "FIFO Cost" },
        { value: "qty", text: "FIFO Qty" },
        { value: "avgCost", text: "Avg. Cost" },
        { value: "margin", text: "Margin" },
        { value: "markup", text: "Markup" },
        { value: 'sale1', text: '1 Yr. Sales' },
        { value: 'sale2', text: '2 Yr. Sales' },
        { value: 'sale3', text: '3 Yr. Sales' },,
        { value: 'lastpocost', text: 'Last PO cost' },
        { value: 'range1', text: 'Sales in Range (this year)' },
        { value: 'range2', text: 'Sales in Range (last year)' },
        { value: 'range3', text: 'Sales in Range (year before last)' },
      ],
      months: [
        { value: 1, text: 'January' },
        { value: 2, text: 'February' },
        { value: 3, text: 'March' },
        { value: 4, text: 'April' },
        { value: 5, text: 'May' },
        { value: 6, text: 'June' },
        { value: 7, text: 'July' },
        { value: 8, text: 'August' },
        { value: 9, text: 'September' },
        { value: 10, text: 'October' },
        { value: 11, text: 'November' },
        { value: 12, text: 'December' }
      ],
      items: [],
      html: "",
      search: {
        partNum: this.$route.query.partNum,
        partDesc: this.$route.query.partDesc,
        monthStart: null,
        monthEnd: null
      },
      sort: {
        field: this.$route.query.field,
        dir: this.$route.query.dir,
      },
      alert: {
        message: "",
        show: false,
        variant: 'warning'
      }
    };
  },

  methods: {
    searchForItems(evt) {
      if (evt != undefined && typeof evt != "string") evt.preventDefault();

      this.alert.show = false;
      this.busy = true;
      this.html = null;
      if (this.search.partNum != "") {
        axios({
          method: "POST",
          headers: { 'Content-Type': 'text/plain' },
          url: `${BASE_API}/ams3-fishioninfo/part-info/search`,
          data: { productNum: this.search.partNum, exactMatch: true }
        }).then(r => {
          if (r.data.length > 0 && r.data[0].item_type == "Kit") {
            this.alert.variant = 'warning'
            this.alert.message = `If you\'re looking for KIT ${r.data[0].product_num}, this page does not have data on KITs.`
            this.alert.show = true
          }
        });
      }
      axios({
        method: "POST",
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/fishbowl/reports/pricing-margin-report`,
        data: { ...this.search, ...this.sort }
      }).then((response) => {
        this.html = response.data;
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
          this.busy = false;
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/purchasing/PricingMarginReport.vue